/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BackgroundCheckCard_delegate = {
    readonly uuid: string;
    readonly firstName: string;
    readonly lastName: string;
    readonly email: string | null;
    readonly profileImageUrl: string | null;
    readonly backgroundCheckPending: boolean;
    readonly hasActiveBackgroundCheck: boolean;
    readonly backgroundChecks: ReadonlyArray<{
        readonly uuid: string;
        readonly approvalDate: string | null;
        readonly expiresAt: string | null;
        readonly isRenewal: boolean;
        readonly isVerification: boolean;
        readonly isCAA: boolean;
        readonly idExpiryDate: string | null;
        readonly dbsExpiryDate: string | null;
        readonly onlyDBS: boolean;
        readonly interviewNotes: {
            readonly yourName: string;
        } | null;
    }> | null;
    readonly " $refType": "BackgroundCheckCard_delegate";
};
export type BackgroundCheckCard_delegate$data = BackgroundCheckCard_delegate;
export type BackgroundCheckCard_delegate$key = {
    readonly " $data"?: BackgroundCheckCard_delegate$data;
    readonly " $fragmentRefs": FragmentRefs<"BackgroundCheckCard_delegate">;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "uuid",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "BackgroundCheckCard_delegate",
        "type": "Delegate",
        "metadata": null,
        "argumentDefinitions": [],
        "selections": [
            (v0 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "firstName",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "lastName",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "email",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "profileImageUrl",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "backgroundCheckPending",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasActiveBackgroundCheck",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "backgroundChecks",
                "storageKey": null,
                "args": null,
                "concreteType": "BackgroundCheck",
                "plural": true,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "approvalDate",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "expiresAt",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isRenewal",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isVerification",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isCAA",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "idExpiryDate",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "dbsExpiryDate",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "onlyDBS",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "interviewNotes",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "InterviewNotes",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "yourName",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = 'edee88a87e7b4223e5b516c28c19d133';
export default node;
